import React, { useEffect, useState } from 'react';
import styles from './style.module.css';

// Define the type for the glitter object
interface Glitter {
  id: number;
  left: number;
  size: number;
  delay: number;
  duration: number;
}

interface GlitterEffectProps {
  numGlitters?: number;
}

const GlitterEffect: React.FC<GlitterEffectProps> = ({ numGlitters = 100 }) => {
  // Explicitly type the state as an array of Glitter objects
  const [glitters, setGlitters] = useState<Glitter[]>([]);

  useEffect(() => {
    // Generate an array of glitter data with random properties
    const generatedGlitters = Array.from({ length: numGlitters }, (_, index) => ({
      id: index,
      left: Math.random() * 100,  // Random horizontal position (percentage)
      size: Math.random() * 6 + 4, // Random size (4px to 10px)
      delay: Math.random() * 5,    // Random animation delay (0s to 5s)
      duration: Math.random() * 5 + 2, // Random animation duration (2s to 7s)
    }));

    setGlitters(generatedGlitters); // Set the glitters state with the generated data
  }, [numGlitters]);

  return (
    <div className={styles.glitterContainer}>
      {glitters.map((glitter) => (
        <div
          key={glitter.id}
          className={styles.glitter}
          style={{
            left: `${glitter.left}%`,
            width: `${glitter.size}px`,
            height: `${glitter.size}px`,
            animationDuration: `${glitter.duration}s`,
            animationDelay: `${glitter.delay}s`,
          }}
        />
      ))}
    </div>
  );
};

export default GlitterEffect;
